import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
export function MobileActionBar() {
  return <div className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-white px-4 pb-[calc(0.75rem+env(safe-area-inset-bottom))] pt-3 shadow-[0_-8px_24px_-12px_rgba(10,37,64,0.25)] lg:hidden" data-id="element-181" data-mp="ar6e6wrhx26n">
      <div className="mx-auto grid max-w-lg grid-cols-[2fr_3fr] gap-3" data-id="element-182" data-mp="jsw5m2ldo14f">
        <a href={business.phoneHref} className="btn-outline !px-3 !py-3.5" data-id="element-183" data-mp="3j9ccnorl4o0r">
          <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-184" data-mp="3n9v25c609hzs" />
          Call
        </a>
        <a href="#estimate" className="btn-primary !px-3 !py-3.5" data-id="element-185" data-mp="3s97s45s6b56l">
          Free Estimate
        </a>
      </div>
    </div>;
}